import React from "react";
import { Modal, Button } from "react-bootstrap";
import ReactAudioPlayer from "react-audio-player";

const AudioPreviewModal = ({
    show,
    onClose,
    audioUrl,
    title = "Audio Preview",
    autoPlay = true
}) => {
    if (!audioUrl) return null;

    const cleanTitle = title.replace(/\.[^/.]+$/, "");

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{cleanTitle}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <ReactAudioPlayer
                    src={audioUrl}
                    controls
                    autoPlay={autoPlay}
                    style={{ width: "100%" }}
                />
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AudioPreviewModal;
